import debug from 'debug';

export const logger = namespace => debug(`mm-client:${namespace}`);
